import { FormikField } from './FormikFields';
import React from 'react';

/**
 * Kept out of FormikFields so that the control modules can reach it without a
 * module-evaluation-order hazard.
 *
 * FormikField maps `component` strings onto the concrete controls, and each
 * control calls this HOC at module scope (`export const FormikTextField =
 * withFormikField(TextField)`). With the HOC defined in FormikFields, whichever
 * side the bundler evaluated first could observe the other uninitialised.
 * Importing the HOC from here resolves it before the control's own body runs,
 * in either evaluation order, because `FormikField` is only dereferenced during
 * render.
 */
export function withFormikField(FormControl, overrideProps) {
    return React.forwardRef(function (props, ref) {
        return <FormikField {...props} {...overrideProps} component={FormControl} ref={ref} />;
    });
}

export default withFormikField;
